<template>
  <div class="table-select">
    <c-input
      v-model="localValue"
      label="Тип таблицы"
      placeholder="Выберите тип таблицы"
      type="select"
      :items="tables"
      :searchable="true"
      :required="error"
      :required-message="error"
      :required-condition="error"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";

export default {
  name: "table-select",
  components: { CInput },
  props: ["value", "error"],
  data() {
    return {
      localValue: null,
      tables: [],
    };
  },
  watch: {
    localValue(v) {
      this.$emit("input", v ? v.value : null);
    },
    value(v) {
      if (!v) {
        if (!this.localValue) return;
        this.localValue = null;
        return;
      }

      if (this.localValue && this.localValue.value === v) return;

      this.localValue = this.tables.find((t) => t.value === v);
    },
  },
  created() {
    this.getTables().then((tables) => {
      this.tables = tables;
      if (this.value) {
        this.localValue = this.tables.find((t) => t.value === this.value);
      }
    });
  },
  methods: {
    getTables() {
      return this.$store
        .dispatch("tablesSettings/getTables")
        .then((tables) => tables.map((t) => ({ value: t.section, label: t.name })));
    },
    onChange() {},
  },
};
</script>

<style lang="scss" scoped>
.table-select {
  max-width: 466px;
}
</style>
